import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketingPlanDetail extends Layout {
    labelD: Label;
    sourceMarketPlanDet: DataSource;
    textboxAssignedUserId: Textbox;
    textboxCode: Textbox;
    textboxDays: Textbox;
    textboxDefAssign: Textbox;
    textboxDescr: Textbox;
    textboxPriority: Textbox;
}
